import classes from "./WorkHours.module.css";
import closeImg from "./assets/Icon.svg";

const ModalUI = (props) => {
  return (
    <div onClick={props.onConfirm} className={classes.backdrop}>
      <div className={classes.background}>
        <div className={classes.modalTitle}>
          <div className={classes.title}>{props.title} 선택</div>
          <button onClick={props.onConfirm} className={classes.modalButton}>
            <img className={classes.closeBtn} src={closeImg} alt="closeBtn" />
          </button>
        </div>
        {props.children}
      </div>
    </div>
  );
};

export default ModalUI;
